import React from 'react';
import { LegalFooter } from './LegalFooter';
import { useT } from '../lib/i18n';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function Privacy() {
  const { t } = useT();
  return (
    <div className="grain min-h-screen flex flex-col bg-[#050510] text-white">
      <div className="flex-1 w-full max-w-4xl mx-auto px-6 py-12 relative">
        <Link to="/" className="inline-flex items-center gap-2 text-[#A0A0B0] hover:text-white transition-colors mb-8 font-bold text-sm bg-white/5 px-4 py-2 rounded-xl hover:bg-white/10">
          <ArrowLeft size={18} /> {t("back_home")}
        </Link>
        <h1 className="font-display text-4xl font-black text-[#FF007F] mb-8">{t("privacy_title")}</h1>
        <div className="space-y-6 text-[#A0A0B0] leading-relaxed text-sm sm:text-base">
           <p>{t("privacy_intro")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("privacy_h1")}</h2>
           <p>{t("privacy_p1")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("privacy_h2")}</h2>
           <p>{t("privacy_p2")}</p>
           <ul className="list-disc pl-5 space-y-2 mt-2">
             <li>{t("privacy_l1")}</li>
             <li>{t("privacy_l2")}</li>
             <li>{t("privacy_l3")}</li>
           </ul>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("privacy_h3")}</h2>
           <p>{t("privacy_p3")}</p>
           <h2 className="text-xl font-bold text-white mt-8 mb-4">{t("privacy_h4")}</h2>
           <p>{t("privacy_p4")}</p>
        </div>
      </div>
      <LegalFooter screen="PRYWATNOŚĆ" />
    </div>
  );
}